<template>
  <div>
    <v-container fluid grid-list-md>
      <progress-bar></progress-bar>
      <v-toolbar class="mb-4">
        <v-toolbar-title>
          Summary report <span v-if="reports && reports.length > 0">from <strong class="accent--text">{{ form.from }}</strong> to <strong class="accent--text">{{ form.to }}</strong></span>
        </v-toolbar-title>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              <v-menu v-model="menu" :return-value="form.from" lazy transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field hide-details v-model="form.from" label="From" v-on="on"></v-text-field>
                </template>
                <v-date-picker locale="ru-ru" :first-day-of-week="1" v-model="form.from" no-title scrollable></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-menu v-model="menu2" :return-value="form.to" lazy transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field hide-details v-model="form.to" label="To" v-on="on"></v-text-field>
                </template>
                <v-date-picker locale="ru-ru" :first-day-of-week="1" v-model="form.to" no-title scrollable></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-btn @click="getReport" color="info" block>Get report</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card v-if="reports && reports.length > 0">
        <v-card-text>
          <v-expansion-panel class="reports_accordion">
            <v-expansion-panel-content class="my-2 elevation-2" v-for="(item, i) in reports" :key="i" v-if="item.total.length > 0">
              <template v-slot:header>
                <div><span>{{ item.name }}</span>, <strong>{{ item.total }}</strong></div>
              </template>
              <v-card>
                <v-card-text class="py-0">
                  <ul class="reports_list" v-for="project in item.projects">
                    <li class="reports_list__item-title">
                      <h4>{{ project.name }}</h4>
                      <strong>{{ project.total }}</strong>
                    </li>
                    <li class="reports_list__line" v-for="time in project.times">
                      <span class="reports_list__line--text">{{ time.description }}</span>
                      <span class="reports_list__line--divider"></span>
                      <span class="reports_list__line--time">{{ time.duration }}</span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'
  import moment from 'moment'

  export default {
    name: 'SummaryReportPage',
    mixins: [mixins.preloader],
    data() {
      return {
        menu: false,
        menu2: false,
        form: {
          from: moment().subtract(7, 'days').format("YYYY-MM-DD"),
          to: moment().add(1, 'day').format("YYYY-MM-DD"),
        },
        reports: []
      }
    },
    methods: {
      getReport() {
        let params = {
          ...this.form
        }

        this.$api.reports.summary(params).then(({data}) => {
          this.reports = data
        })
      },
    },
  }
</script>
